import type { ReactNode } from 'react';
import { QueryClient, QueryClientProvider as ReactQueryProvider } from '@tanstack/react-query';

import { CurrentUserContextProvider } from '../../../users/contexts/CurrentUserContext';

let queryClientSingleton: QueryClient;

function getQueryClient(): QueryClient {
  if (!queryClientSingleton) {
    queryClientSingleton = new QueryClient({
      defaultOptions: {
        queries: {
          refetchOnWindowFocus: false,
          retry: 1,
        },
      },
    });
  }
  return queryClientSingleton;
}

function DataConnectProvider({
  children,
  withoutUserContext = false,
}: {
  children: ReactNode;
  withoutUserContext?: boolean;
}) {
  const queryClient = getQueryClient();
  const withUserContext = !withoutUserContext;
  return (
    <ReactQueryProvider client={queryClient}>
      {withUserContext ? (
        <CurrentUserContextProvider>{children}</CurrentUserContextProvider>
      ) : (
        children
      )}
    </ReactQueryProvider>
  );
}

export default DataConnectProvider;
